// City landing pages structured data for Rajasthan hubs
export const CITIES_DATA = {
  jaipur: {
    slug: "jaipur",
    legacyPath: "/stock-market-course-in-jaipur",
    name: "Jaipur",
    heroHeading: "No.1 Stock Market Course in Jaipur with Lifetime Mentorship",
    heroSubheading: "Join Rajasthan's premier stock market institute. Learn demand-supply order flow, price action, and option derivatives directly from NISM-certified trader Deepak Sethia at our live trading floor.",
    centerType: "Flagship Physical Institute & Live Market Trading Floor",
    address: "3rd Floor, Ajmer Road, Opposite MG Motors, Heera Nagar, Tagore Nagar, Jaipur, Rajasthan 302021",
    landmarks: "Opposite MG Motors, Near Heera Nagar / DCM / 200 Feet Bypass",
    phone: "+91 92570 59361",
    email: "contactus@jamadhan.com",
    metaTitle: "No.1 Stock Market Course in Jaipur with Lifetime Mentorship | JamaDhan",
    metaDescription: "Learn stock trading in Jaipur with NISM-certified mentorship - live offline trading floor & interactive online batches, real fee transparency. Enroll now.",
    heroBadge: "Jaipur Flagship Institute • 10,000+ Alumni",
    rating: "4.95/5",
    reviewCount: "1,480+ Verified Reviews",
    batchStatus: "🟢 Offline & Online Batches Enrolling • Next Batch Starts Monday",
    heroImage: "/images/cities/city_academy_hero.jpg",
    mentorImage: "/images/cities/deepak_sir_real.png",
    facilityImage: "/trading_floor.png",
    receptionImage: "/jamadhan_reception.webp",
    networkImage: "/images/cities/rajasthan_trading_grid.jpg",
    classroomMode: "Both Physical Offline Classroom & Live 4K Online Sessions",
    stats: [
      { label: "Students Trained", value: "10,000+", change: "+120 this month" },
      { label: "Jaipur Alumni Rating", value: "4.95 / 5", change: "Verified Google Reviews" },
      { label: "Live Trading Floor", value: "35+ Terminals", change: "Market hours practice" },
      { label: "Active Mentorship", value: "Lifetime", change: "Daily market guidance" },
    ],
    localizedStory: `Founded in the heart of the Pink City, JamaDhan's Jaipur flagship institute is home to Rajasthan's most modern live trading floor. With high-tech multi-screen workstations, live market trade executions from 9:15 AM to 3:30 PM, and direct one-on-one mentorship by Deepak Sethia, students from Mansarovar, Vaishali Nagar, Malviya Nagar, Raja Park, and across Jaipur build disciplined, profitable market careers.`,
    centerFeatures: [
      "Physical Live Trading Floor with high-speed multi-monitor setups",
      "Live market execution sessions with Deepak Sir (9:15 AM - 3:30 PM)",
      "Daily post-market recap & personalized trading journal reviews",
      "Air-conditioned student collaboration lounge & research library",
      "Official Certification of Completion issued upon graduation",
      "Lifetime repeat batch audit permission (offline & online)"
    ],
    nearbyAreas: ["Mansarovar", "Vaishali Nagar", "Malviya Nagar", "Tonk Road", "C-Scheme", "Raja Park", "Jhotwara", "Vidhyadhar Nagar"]
  },
  jodhpur: {
    slug: "jodhpur",
    legacyPath: "/stock-market-classes-in-jodhpur",
    name: "Jodhpur",
    heroHeading: "Best Stock Market Classes in Jodhpur | NISM Certified Mentorship",
    heroSubheading: "Turn business acumen into disciplined stock trading. Learn institutional demand-supply price action and option strategies with Rajasthan's premier stock market institute.",
    centerType: "Jodhpur Regional Hub & Interactive Live Digital Desk",
    address: "Regional Cohort: Ratanada Road, Near Sardarpura, Jodhpur, Rajasthan 342001 (Direct Support & Access to Jaipur Trading Floor)",
    landmarks: "Sardarpura / Ratanada / Paota Zone",
    phone: "+91 92570 59361",
    email: "contactus@jamadhan.com",
    metaTitle: "Best Stock Market Classes in Jodhpur | NISM Certified Mentorship | JamaDhan",
    metaDescription: "Join top-rated stock market classes in Jodhpur. Learn price action, options trading, and risk management with live market practice.",
    heroBadge: "Jodhpur Sun City Trading Hub • NISM Certified",
    rating: "4.92/5",
    reviewCount: "920+ Verified Reviews",
    batchStatus: "🟢 Live Jodhpur Batch Enrolling • Morning & Evening Slots",
    heroImage: "/images/cities/city_academy_hero.jpg",
    mentorImage: "/images/cities/deepak_sir_real.png",
    facilityImage: "/trading_floor.png",
    receptionImage: "/jamadhan_reception.webp",
    networkImage: "/images/cities/rajasthan_trading_grid.jpg",
    classroomMode: "Interactive Live Digital Sessions + Offline Weekend Workshops",
    stats: [
      { label: "Jodhpur Traders", value: "2,200+", change: "Active community" },
      { label: "Batch Success Rate", value: "94.8%", change: "Disciplined risk rules" },
      { label: "Option Win-Ratio", value: "1 : 2.5", change: "Average Risk:Reward" },
      { label: "Mentorship", value: "Lifetime", change: "Direct access to Deepak Sir" },
    ],
    localizedStory: `Renowned for entrepreneurship and trade heritage, Jodhpur traders are ditching speculative tip channels in favor of calculated, probability-driven strategies. Our Jodhpur cohorts learn how to read institutional footprint candles, map high-conviction order blocks, and trade Index options with strict stop-losses.`,
    centerFeatures: [
      "Live interactive classes with real-time screen sharing and Q&A",
      "Dedicated Jodhpur student cohort Telegram channel for daily setups",
      "Exclusive access to weekend hands-on workshops in Jaipur",
      "Personalized risk calculator configured for capital sizes from ₹25K to ₹25L+",
      "Lifetime recording library with HD 4K video access",
      "NISM-aligned curriculum certified by industry veterans"
    ],
    nearbyAreas: ["Sardarpura", "Ratanada", "Paota", "Shastri Nagar", "Chopasni Road", "Pal Road", "Air Force Area", "Mandore"]
  },
  udaipur: {
    slug: "udaipur",
    legacyPath: "/stock-market-classes-in-udaipur",
    name: "Udaipur",
    heroHeading: "Best Stock Market Classes in Udaipur | Price Action & Options",
    heroSubheading: "Master wealth compounding and professional derivative trading in the City of Lakes. Taught by Deepak Sethia with 12+ years of institutional trading expertise.",
    centerType: "Udaipur Elite Cohort & Live Market Masterclass",
    address: "Regional Hub: Near Sukher & Chetak Circle, Udaipur, Rajasthan 313001",
    landmarks: "Chetak Circle / Sukher / Panchwati connectivity",
    phone: "+91 92570 59361",
    email: "contactus@jamadhan.com",
    metaTitle: "Best Stock Market Classes in Udaipur | Price Action & Options | JamaDhan",
    metaDescription: "Premier stock market institute for Udaipur traders. Master technical analysis, options hedging, and institutional price action.",
    heroBadge: "Udaipur Lake City Financial Cohort • 4.88 Rating",
    rating: "4.88/5",
    reviewCount: "780+ Verified Reviews",
    batchStatus: "🟢 New Udaipur Batch Starting This Monday",
    heroImage: "/images/cities/city_academy_hero.jpg",
    mentorImage: "/images/cities/deepak_sir_real.png",
    facilityImage: "/trading_floor.png",
    receptionImage: "/jamadhan_reception.webp",
    networkImage: "/images/cities/rajasthan_trading_grid.jpg",
    classroomMode: "Live Hybrid Online & Intensive Regional Meetups",
    stats: [
      { label: "Udaipur Alumni", value: "1,600+", change: "Full-time & swing traders" },
      { label: "Student Rating", value: "4.88 / 5", change: "Exceptional student feedback" },
      { label: "Capital Protected", value: "₹4.5Cr+", change: "Through risk sizing rules" },
      { label: "Doubt Clearance", value: "Daily", change: "Live interactive desk" },
    ],
    localizedStory: `From local business founders around Sukher and Chetak Circle to students at Mohanlal Sukhadia University, Udaipur learners are building secondary income streams through disciplined market execution. JamaDhan provides the exact framework needed to navigate volatile market regimes with composure.`,
    centerFeatures: [
      "Live trading room access during Indian market hours (9:15 - 3:30)",
      "Institutional order flow and volume profile analysis",
      "Hedging strategies tailored for business owners with existing capital",
      "Lifetime mentorship and continuous trade review feedback",
      "Official Certificate of Completion and career mentorship support",
      "Full integration with Drishti AI momentum scanner"
    ],
    nearbyAreas: ["Chetak Circle", "Sukher", "Panchwati", "Fatehpura", "Hiran Magri", "Goverdhan Vilas", "Bhuwana", "Sobhagpura"]
  },
  kota: {
    slug: "kota",
    legacyPath: "/stock-market-classes-in-kota",
    name: "Kota",
    heroHeading: "Stock Market Classes in Kota | Analytical & Price Action Trading",
    heroSubheading: "Turn Kota's mathematical rigor into a competitive trading edge. Learn algorithmic mindset, price action patterns, and options probability modeling.",
    centerType: "Kota Analytical Trading Hub & Virtual Trading Floor",
    address: "Regional Hub: Near Vigyan Nagar & Talwandi, Kota, Rajasthan 324005",
    landmarks: "Talwandi / Vigyan Nagar / Aerodrome Circle",
    phone: "+91 92570 59361",
    email: "contactus@jamadhan.com",
    metaTitle: "Stock Market Classes in Kota | Algorithmic & Price Action Trading | JamaDhan",
    metaDescription: "Learn disciplined, rule-based stock and derivative trading in Kota with SEBI/NISM curriculum and live market mentorship.",
    heroBadge: "Kota Mathematical Edge • High Precision Trading",
    rating: "4.91/5",
    reviewCount: "840+ Verified Reviews",
    batchStatus: "🟢 Kota Weekend & Evening Slots Filling Fast",
    heroImage: "/images/cities/city_academy_hero.jpg",
    mentorImage: "/images/cities/deepak_sir_real.png",
    facilityImage: "/trading_floor.png",
    receptionImage: "/jamadhan_reception.webp",
    networkImage: "/images/cities/rajasthan_trading_grid.jpg",
    classroomMode: "Interactive Digital Cohort + Weekend Deep-Dives",
    stats: [
      { label: "Kota Students", value: "1,850+", change: "Engineers & professionals" },
      { label: "Avg Risk:Reward", value: "1 : 3", change: "Systematic setups" },
      { label: "Curriculum Modules", value: "35 Sessions", change: "End-to-end mastery" },
      { label: "Mentorship", value: "Lifetime", change: "Real-time doubt resolution" },
    ],
    localizedStory: `Known across India for academic excellence, Kota's students, educators, and working professionals appreciate JamaDhan's systematic, data-backed approach. We treat stock trading not as luck, but as applied probability, quantitative risk management, and human psychology.`,
    centerFeatures: [
      "Rigorous probability-based trade execution framework",
      "Step-by-step risk management protocols preventing account wipeouts",
      "Options Greek sensitivity analysis (Delta, Theta, Gamma, Vega)",
      "Flexible evening and weekend batches tailored for busy schedules",
      "Hands-on backtesting tools and live scanner integration",
      "Lifetime membership to JamaDhan's active trader network"
    ],
    nearbyAreas: ["Talwandi", "Vigyan Nagar", "Mahaveer Nagar", "Dadabari", "Kunhari", "Gumanpura", "Indra Vihar", "Rajeev Gandhi Nagar"]
  },
  ajmer: {
    slug: "ajmer",
    legacyPath: "/stock-market-classes-in-ajmer",
    name: "Ajmer",
    heroHeading: "Stock Market Classes in Ajmer | Learn Stock Trading & Options",
    heroSubheading: "Central Rajasthan's premier pathway to financial independence. Hands-on candlestick analysis, demand-supply charting, and option income strategies.",
    centerType: "Ajmer-Pushkar Direct Cohort & Flagship Weekend Access",
    address: "Regional Cohort: Civil Lines / Vaishali Nagar, Ajmer, Rajasthan 305001 (Direct Highway Access to Jaipur Trading Floor)",
    landmarks: "Civil Lines / Vaishali Nagar / Ana Sagar Circular Road",
    phone: "+91 92570 59361",
    email: "contactus@jamadhan.com",
    metaTitle: "Stock Market Classes in Ajmer | Learn Stock Trading & Options | JamaDhan",
    metaDescription: "Empowering traders across Ajmer and Pushkar with professional stock market training, option buying/selling strategies & lifetime support.",
    heroBadge: "Ajmer Regional Institute • Direct Highway Access to Jaipur",
    rating: "4.89/5",
    reviewCount: "650+ Verified Reviews",
    batchStatus: "🟢 Ajmer Batch Enrolling • Limited Seats",
    heroImage: "/images/cities/city_academy_hero.jpg",
    mentorImage: "/images/cities/deepak_sir_real.png",
    facilityImage: "/trading_floor.png",
    receptionImage: "/jamadhan_reception.webp",
    networkImage: "/images/cities/rajasthan_trading_grid.jpg",
    classroomMode: "Live Interactive Digital Batches + Jaipur Physical Trading Floor Access",
    stats: [
      { label: "Ajmer Alumni", value: "1,200+", change: "Traders from Ajmer & Pushkar" },
      { label: "Jaipur Floor Visits", value: "Unlimited", change: "Weekend live floor access" },
      { label: "Batch Rating", value: "4.89 / 5", change: "Verified student rating" },
      { label: "Course Support", value: "Lifetime", change: "Daily market hours support" },
    ],
    localizedStory: `Just an hour and a half away from our Jaipur flagship center, traders in Ajmer enjoy the ultimate advantage: interactive live daily classes combined with open weekend invitations to trade live on Jaipur's state-of-the-art multi-screen trading floor.`,
    centerFeatures: [
      "Seamless hybrid structure: attend live online or visit Jaipur trading floor",
      "Live order-book dissection and institutional supply zone identification",
      "Special weekend masterclasses for Ajmer working professionals",
      "Direct WhatsApp and phone access to mentor Deepak Sethia",
      "Official Certification recognized across Indian financial community",
      "Recorded video archive with lifetime uninterrupted playback"
    ],
    nearbyAreas: ["Civil Lines", "Vaishali Nagar", "Panchsheel Nagar", "Adarsh Nagar", "Makhupura", "Pushkar Road", "Christian Ganj", "Kishangarh"]
  },
  sikar: {
    slug: "sikar",
    legacyPath: "/stock-market-classes-in-sikar",
    name: "Sikar",
    heroHeading: "Best Share Market Classes in Sikar | Complete Trading Course",
    heroSubheading: "Shekhawati's most trusted stock market training institute. Learn how to trade stocks, Nifty, and BankNifty independently with proven rule-based setups.",
    centerType: "Shekhawati Regional Cohort & Live Digital Institute",
    address: "Regional Center: Station Road / Piprali Road Zone, Sikar, Rajasthan 332001",
    landmarks: "Piprali Road / Station Road / Kalyan Circle",
    phone: "+91 92570 59361",
    email: "contactus@jamadhan.com",
    metaTitle: "Best Share Market Classes in Sikar | Complete Trading Course | JamaDhan",
    metaDescription: "Top share market training in Sikar. Master candlestick analysis, trend breakouts, and risk management with Deepak Sir.",
    heroBadge: "Sikar Shekhawati Hub • Trusted by 1,400+ Students",
    rating: "4.93/5",
    reviewCount: "710+ Verified Reviews",
    batchStatus: "🟢 New Shekhawati Batch Starts Monday",
    heroImage: "/images/cities/city_academy_hero.jpg",
    mentorImage: "/images/cities/deepak_sir_real.png",
    facilityImage: "/trading_floor.png",
    receptionImage: "/jamadhan_reception.webp",
    networkImage: "/images/cities/rajasthan_trading_grid.jpg",
    classroomMode: "Live Online Interactive Sessions + Personal Doubt Mentorship",
    stats: [
      { label: "Sikar Learners", value: "1,450+", change: "Shekhawati region" },
      { label: "Hindi Medium", value: "100%", change: "Clear, relatable delivery" },
      { label: "Capital Survival", value: "98.2%", change: "Strict stop-loss discipline" },
      { label: "Lifetime Mentorship", value: "Included", change: "Daily post-market guidance" },
    ],
    localizedStory: `From student communities on Piprali Road to agricultural and business entrepreneurs across Shekhawati, people in Sikar are mastering the Indian share market. Deepak Sir breaks down complex institutional concepts into simple, practical Hindi explanations with crystal-clear rules.`,
    centerFeatures: [
      "Simplified Hindi instruction with zero financial jargon",
      "Practical live market examples using familiar Indian companies",
      "Strict trade management preventing common beginner blunders",
      "Active trader peer group connecting students across Sikar & Jhunjhunu",
      "Full access to class notes, checklists, and trade setup sheets",
      "Certificate of Completion with NISM-aligned curriculum"
    ],
    nearbyAreas: ["Piprali Road", "Station Road", "Kalyan Circle", "Fatehpur Road", "Bajaj Road", "Silver Jubilee Road", "Nechhwa", "Laxmangarh"]
  },
  bhilwara: {
    slug: "bhilwara",
    legacyPath: "/stock-market-classes-in-bhilwara",
    name: "Bhilwara",
    heroHeading: "Stock Market Classes in Bhilwara | Business Owner & Trader Programs",
    heroSubheading: "The Textile City's gateway to capital market mastery. Learn how to grow and hedge business wealth with high-probability equity and option strategies.",
    centerType: "Bhilwara Business & Wealth Creation Cohort",
    address: "Regional Hub: Bhopal Ganj / Love Garden Road, Bhilwara, Rajasthan 311001",
    landmarks: "Bhopal Ganj / Subhash Nagar / Love Garden Zone",
    phone: "+91 92570 59361",
    email: "contactus@jamadhan.com",
    metaTitle: "Stock Market Classes in Bhilwara | Business Owner & Trader Programs | JamaDhan",
    metaDescription: "Professional stock market and options training in Bhilwara for business owners, investors, and traders. Learn hedging, swing trading, and wealth compounding.",
    heroBadge: "Bhilwara Wealth Cohort • 4.90 Rating",
    rating: "4.90/5",
    reviewCount: "590+ Verified Reviews",
    batchStatus: "🟢 Bhilwara Business & Trader Batch Enrolling",
    heroImage: "/images/cities/city_academy_hero.jpg",
    mentorImage: "/images/cities/deepak_sir_real.png",
    facilityImage: "/trading_floor.png",
    receptionImage: "/jamadhan_reception.webp",
    networkImage: "/images/cities/rajasthan_trading_grid.jpg",
    classroomMode: "Live Digital Masterclass + Customized Capital Sessions",
    stats: [
      { label: "Bhilwara Alumni", value: "1,100+", change: "Business owners & traders" },
      { label: "Portfolio Growth", value: "Consistent", change: "Hedging + swing strategies" },
      { label: "Student Rating", value: "4.91 / 5", change: "Unanimous 5-star feedback" },
      { label: "Mentor Access", value: "Direct", change: "Personal portfolio feedback" },
    ],
    localizedStory: `Bhilwara is world-famous for manufacturing and commerce. JamaDhan equips Bhilwara's entrepreneurs and young investors with the exact frameworks used by large institutions to compound business profits, hedge downside market shocks, and write monthly options for regular cash flow.`,
    centerFeatures: [
      "Customized modules for business owners seeking secondary cash flows",
      "Derivative hedging tactics to protect substantial equity holdings",
      "Swing trading setups requiring just 15-30 minutes of daily attention",
      "One-on-one portfolio structure review with Deepak Sethia",
      "Lifetime mentorship and invitation to all future alumni masterclasses",
      "Official Certificate of Completion graduation credential"
    ],
    nearbyAreas: ["Bhopal Ganj", "Subhash Nagar", "Love Garden", "Pur Road", "Azad Nagar", "Patel Nagar", "Chittorgarh Road", "Mandal"]
  }
};

export const CITY_COURSES = [
  {
    id: "smart-trader-elementary",
    slug: "smart-trader-elementary",
    title: "Smart Trader Elementary Course",
    subtitle: "Foundational Primer for Absolute Beginners",
    level: "Beginner Level",
    sessions: "7 Live Sessions",
    duration: "7 Days",
    fee: "FREE",
    originalFee: "",
    badge: "Free Course",
    popular: false,
    tagline: "Zero-commitment, high-value introduction to stock market fundamentals, charting basics, and JamaDhan's teaching methodology.",
    highlights: [
      "Zero prior financial background needed",
      "Live candlestick chart reading on TradingView",
      "Understanding retail traps & 90% loss math",
      "Direct live Q&A session with Deepak Sir"
    ],
    toolsCovered: ["TradingView", "NSE India Portal", "Demat Order Setup"],
    outcome: "Understand how the stock market actually functions, place orders with confidence, and avoid rookie mistakes.",
    modules: [
      "Stock Market Basics: What is BSE, NSE, Demat & Trading Accounts?",
      "Order Types Mastered: Market, Limit, Stop-Loss (SL), and Bracket Orders",
      "Reading Your First Candlestick Chart: Green vs Red, Wicks & Body Psychology",
      "Common Traps Beginners Fall Into (Telegram tips, overleveraging, FOMO)",
      "The Math of Risk & Capital Preservation: Why 90% of Retail Traders Lose",
      "Introduction to Institutional Supply-Demand Zones vs Retail Indicators",
      "Direct Q&A Session with Deepak Sir & Personalized Full-Time Roadmap"
    ]
  },
  {
    id: "technical-analysis-course",
    slug: "technical-analysis-course",
    title: "Super Trader Edge Course",
    subtitle: "Complete Price Action & Demand-Supply Mastery",
    level: "Intermediate to Pro",
    sessions: "25 Live Sessions",
    duration: "~6–8 Weeks",
    fee: "₹15,000",
    originalFee: "₹25,000",
    badge: "Core Price Action",
    popular: false,
    tagline: "Build an institutional foundation in price action, candlestick psychology, multi-timeframe trends, and market auction theory.",
    highlights: [
      "25 In-depth live market coaching sessions",
      "Institutional Demand & Supply order blocks",
      "Multi-timeframe trend alignment (Monthly to 5M)",
      "Custom risk calculator & position sizing sheets"
    ],
    toolsCovered: ["TradingView Pro", "Volume Profile", "Custom Risk Calculator", "Drishti AI"],
    outcome: "Trade stocks, indices, and swing setups purely based on institutional order flow with minimum 1:2 risk-to-reward.",
    modules: [
      "Why Technical Analysis Works: Auction Theory & Liquidity Engineering",
      "Demand & Supply Zones: Pinpointing True Institutional Order Blocks",
      "Multi-Timeframe Top-Down Analysis: Aligning Monthly, Weekly & Intraday Trends",
      "Live Market Stock Scanning: Filtering High-Momentum Breakouts & Runners",
      "Sector Rotation & Relative Strength: Riding Institutional Money Flow",
      "Advanced Candlestick Psychology: Rejections, Absorption & Trap Exhaustion",
      "False Breakout Detection: How Big Institutions Hunt Retail Stop Losses",
      "Non-Negotiable Risk Management: Capital Protection & Sizing Formulas"
    ]
  },
  {
    id: "options-trading-course",
    slug: "options-trading-course",
    title: "Super Option Analysis Course",
    subtitle: "Derivatives, Hedging & Expiry Strategies",
    level: "Advanced Derivatives",
    sessions: "10 Intensive Sessions",
    duration: "~3–4 Weeks",
    fee: "₹20,000",
    originalFee: "₹25,000",
    badge: "High ROI Skill",
    popular: false,
    tagline: "Master Nifty, BankNifty & FinNifty options buying and selling with mathematical Greek hedging and open interest data.",
    highlights: [
      "10 High-impact derivative workshops",
      "Option Greeks mastery (Delta, Theta, Vega, Gamma)",
      "Hedging models: Iron Condors, Straddles & Credit Spreads",
      "Zero-Hero expiry day momentum sniper setups"
    ],
    toolsCovered: ["Sensibull", "NSE Option Chain", "OI Pulse", "TradingView"],
    outcome: "Build consistent weekly cash flow through hedged option selling and capture high-momentum directional option buying moves.",
    modules: [
      "Option Basics from Scratch: Call & Put Mechanics, Strike Selection & Intrinsic Value",
      "Option Greeks Decoded: Managing Delta, Theta Decay, Vega Shocks & Gamma Risk",
      "Open Interest (OI) & PCR Interpretation: Decoding Smart Money Positions",
      "Directional Option Buying: Catching Fast Breakouts with Minimal Premium Decay",
      "Non-Directional Option Selling: Credit Spreads & Iron Condors for Steady Income",
      "Weekly Expiry Playbook: Straddles, Strangles & Zero-Hero Scalp Rules",
      "Live Fire Adjustment Techniques: Defending Trades When Markets Reverse",
      "F&O Risk Mitigation: Position Sizing & Margin Optimization Strategies"
    ]
  },
  {
    id: "technical-analysis-options-combo-course",
    slug: "technical-analysis-options-combo-course",
    title: "Super Trader Combo",
    subtitle: "Complete Technical Analysis + Option Trading Mastery",
    level: "All-in-One Flagship",
    sessions: "35 Total Sessions",
    duration: "~10–12 Weeks",
    fee: "₹25,000",
    originalFee: "₹45,000",
    badge: "Ultimate Mentorship",
    popular: true,
    tagline: "The definitive full-stack trading program. Master both cash equity price action and advanced derivative hedging with live trading floor access.",
    highlights: [
      "Full access to ALL 25 Technical + ALL 10 Options Sessions",
      "Live Market Trading Floor access during active trading hours",
      "1-on-1 Personal Portfolio & Trade Journal Audits with Deepak Sir",
      "3 Months Free Drishti AI Pro Scanner & Lifetime Community"
    ],
    toolsCovered: ["TradingView Pro", "Sensibull", "Drishti AI Terminal", "Live Floor Desks"],
    outcome: "Become a completely self-sufficient, full-time trader equipped with technical analysis, derivative hedging, and algorithmic screening.",
    modules: [
      "All 25 Sessions of Super Trader Edge Technical Analysis",
      "All 10 Sessions of Super Options Analysis & Derivative Hedging",
      "Physical / Virtual Live Market Trading Floor Access (9:15 AM - 3:30 PM)",
      "1-on-1 Personal Trade Journal & Capital Sizing Audits with Deepak Sir",
      "Drishti AI Pro Scanner Integration (3 Months Full Access Included)",
      "Lifetime Repeat Attendance (Audit any future online or offline batch for free)",
      "Priority WhatsApp VIP Hotline for Real-Time Doubt Clarification",
      "Lifetime Access to 10,000+ Alumni Trader Community & Weekly Masterclasses"
    ]
  }
];

export const LEARNING_TRACKS = [
  {
    id: "live-market-floor",
    name: "Live Market Floor Residency",
    badge: "Flagship Mentorship",
    idealFor: "For traders who want to learn during live market hours with Deepak Sir.",
    schedule: "Synced to live market hours, agreed with your mentor.",
    highlights: [
      "Live market sessions on the trading floor",
      "Trade journal reviews and stop-loss discipline coaching",
      "Dual-screen terminal access"
    ]
  },
  {
    id: "working-professionals",
    name: "Executive & Working Professional Track",
    badge: "Flexible Schedule",
    idealFor: "For doctors, engineers, executives, and business owners.",
    schedule: "Evening and weekend sessions, coordinated with your cohort.",
    highlights: [
      "Recorded session library with lifetime re-watch access",
      "Post-market debriefs",
      "Weekend strategy workshops"
    ]
  },
  {
    id: "bespoke-1on1",
    name: "1-on-1 Personalised Masterclass",
    badge: "Private Mentorship",
    idealFor: "For traders who want focused, individual guidance.",
    schedule: "Custom timing, set directly with Deepak Sir.",
    highlights: [
      "Personalised roadmap based on your capital and risk profile",
      "One-to-one doubt solving",
      "Private floor terminal or dedicated studio"
    ]
  }
];

export const BATCH_SCHEDULES = LEARNING_TRACKS;

export const PROGRAM_COMPARISON = [
  {
    feature: "Program Duration",
    elementary: "7 Days",
    technical: "6-8 Weeks (25 Sessions)",
    options: "3-4 Weeks (10 Sessions)",
    combo: "10-12 Weeks (35 Sessions)"
  },
  {
    feature: "Learning Format",
    elementary: "Both Live Online & Offline",
    technical: "Both Live Online & Offline Classroom",
    options: "Both Live Online & Offline Classroom",
    combo: "Both Live Online & Offline Floor Access"
  },
  {
    feature: "Demand & Supply Price Action",
    elementary: "Basics only",
    technical: "Institutional Order Blocks",
    options: "Directional Bias only",
    combo: "Full Multi-Timeframe Order Flow"
  },
  {
    feature: "Option Greeks & Hedging",
    elementary: "—",
    technical: "—",
    options: "Delta, Theta, Vega & Adjustments",
    combo: "Full Derivative Buying & Selling Mastery"
  },
  {
    feature: "Live Market Floor Execution (9:15-3:30)",
    elementary: "—",
    technical: "5 Live Sessions",
    options: "3 Live Expiry Days",
    combo: "Full Residency Access during Program"
  },
  {
    feature: "Drishti AI Market Intelligence",
    elementary: "—",
    technical: "3 Months Free Access",
    options: "3 Months Free Access",
    combo: "3 Months Free Pro Access"
  },
  {
    feature: "Lifetime Doubt Clearance & Mentorship",
    elementary: "7 Days",
    technical: "Lifetime Mentorship",
    options: "Lifetime Mentorship",
    combo: "VIP Direct Access to Deepak Sir + Alumni Network"
  },
  {
    feature: "Course Certification",
    elementary: "Certificate of Participation",
    technical: "Official Certification",
    options: "Official Certification",
    combo: "Master Trader Certification"
  },
  {
    feature: "Course Fee",
    elementary: "100% Free",
    technical: "₹15,000",
    options: "Enquire for Batch Fee",
    combo: "Best Value Master Bundle"
  }
];

export const VIDEO_TESTIMONIALS = [
  {
    id: 1,
    title: "From Absolute Beginner to Disciplined Independent Trader",
    student: "Pankaj Sharma",
    city: "Jaipur",
    tag: "Batch Alumni",
    videoSrc: "/review_video_1.mp4",
    quote: "Deepak Sir breaks down institutional demand and supply zones in pure practical Hindi. The live trading floor environment removed all my fear."
  },
  {
    id: 2,
    title: "Recovered Past Capital by Learning Option Adjustments",
    student: "Rajesh Soni",
    city: "Jodhpur",
    tag: "Options Cohort",
    videoSrc: "/review_video_2.mp4",
    quote: "Before JamaDhan, I lost capital following anonymous Telegram calls. Learning the math of option Greeks gave me complete control over risk."
  },
  {
    id: 3,
    title: "Trading Live Side-by-Side During Market Hours",
    student: "Ankit Jain",
    city: "Kota",
    tag: "Super Trader Combo",
    videoSrc: "/review_video_3.mp4",
    quote: "Trading live with Deepak Sir from 9:15 AM to 3:30 PM is irreplaceable. You see setups being planned and executed with exact stop losses."
  },
  {
    id: 4,
    title: "Lifetime Mentorship is Real — Constant Support",
    student: "Meena Choudhary",
    city: "Udaipur",
    tag: "Mentorship Alumni",
    videoSrc: "/review_video_4.mp4",
    quote: "Even months after graduating, Deepak Sir personally reviews my trade journal and answers questions in weekly live alumni sessions."
  }
];

export const STUDENT_TESTIMONIALS = [
  {
    name: "Shalendra Gupta",
    role: "Full-Time Trader • Jaipur",
    rating: 5,
    avatar: "/images/cities/deepak_sir_real.png",
    content: "Jama Dhan is genuinely the best institute for beginners to learn about the share market. The friendly environment and limited seats ensure equal attention. Deepak Sir explains every single concept in depth and never moves forward until everyone's doubt is cleared. His daily revision before starting a new topic makes everything connect smoothly."
  },
  {
    name: "Gaurav Agarwal",
    role: "Swing Trader • Jodhpur",
    rating: 5,
    avatar: "/about_deepak.webp",
    content: "I joined JamaDhan after losing capital on random Telegram advisory tips. Deepak Sir's demand-supply zone methodology completely transformed my perspective. Now I wait patiently for institutional levels instead of chasing green candles. Lifetime mentorship is 100% real — Sir answers doubts even months after course completion."
  },
  {
    name: "Pooja Choudhary",
    role: "Options Trader • Udaipur",
    rating: 5,
    avatar: "/deepak-sir.webp",
    content: "The Options Trading module was an absolute eye-opener! Option Greeks and Open Interest used to intimidate me, but the live market sessions made it crystal clear. Learning adjustments when the market turns against you gave me the confidence to trade without panic."
  },
  {
    name: "Mohit Sharma",
    role: "Equity Trader • Kota",
    rating: 5,
    avatar: "/images/cities/deepak_sir_real.png",
    content: "As someone who loves mathematics and data, JamaDhan's rule-based approach resonated with me immediately. No gambling, no gut feelings — just strict risk-reward ratios and probability. Highly recommended for anyone in Kota serious about trading!"
  }
];

export const CITY_PATHS = {
  jaipur: "/stock-market-course-in-jaipur/",
  jodhpur: "/stock-market-classes-in-jodhpur/",
  udaipur: "/stock-market-classes-in-udaipur/",
  kota: "/stock-market-classes-in-kota/",
  ajmer: "/stock-market-classes-in-ajmer/",
  sikar: "/stock-market-classes-in-sikar/",
  bhilwara: "/stock-market-classes-in-bhilwara/",
};

export const CITY_FAQS_BY_SLUG = {
  jaipur: [
    {
      question: "Where is JamaDhan's Jaipur flagship institute located and what are the trading floor hours?",
      answer: "Our flagship academy is located on the 3rd Floor, Ajmer Road, opposite MG Motors, Heera Nagar (near 200 Feet Bypass / DCM), Jaipur, Rajasthan 302021. The live market trading floor operates during active market hours from 9:15 AM to 3:30 PM, Monday through Friday, with direct mentorship from Deepak Sethia."
    },
    {
      question: "Can students from outside Jaipur or areas like Mansarovar get hostel / PG accommodation support?",
      answer: "Yes! Many students travel from across Rajasthan and other states to study on our live trading floor. Our admissions desk assists outstation candidates with vetted PG and hostel accommodations within walking distance or direct bus/metro connectivity to our Heera Nagar academy."
    },
    {
      question: "How does live market trading execution work during classroom batches in Jaipur?",
      answer: "Unlike institutes that teach only post-market theory on weekends, JamaDhan Jaipur students sit at multi-monitor trading terminals during active market hours. You observe live candlestick formation, institutional order blocks, and execute live trades under Deepak Sir's direct supervision with strict risk parameters."
    },
    {
      question: "Can I attend offline Jaipur classes on weekends if I am a working professional or doctor?",
      answer: "Yes! We run dedicated Weekend Executive Batches (Saturday and Sunday) tailored for working professionals, doctors, business owners, and engineers in Jaipur who cannot attend weekday market hours."
    },
    {
      question: "Is vehicle parking available at the Jaipur center?",
      answer: "Yes, ample two-wheeler and four-wheeler parking is available on-site at our Ajmer Road premises, with elevator access directly to our 3rd-floor academy floor."
    },
    {
      question: "Can Jaipur students repeat future offline batches if they need revision?",
      answer: "Yes. Under our Lifetime Mentorship policy, enrolled students in our core programs enjoy lifetime repeat audit privileges — you can attend future offline classroom batches or live digital sessions anytime without paying additional course fees."
    }
  ],

  jodhpur: [
    {
      question: "How can students and business owners in Jodhpur attend JamaDhan's stock market classes?",
      answer: "Jodhpur traders can join our high-definition interactive live digital batches with two-way screen sharing, voice Q&A, and dedicated Jodhpur student cohort Telegram support. Additionally, Jodhpur students receive open invitations to attend physical live trading floor sessions at our Jaipur flagship center anytime."
    },
    {
      question: "Are the Jodhpur batch timings suitable for business owners in Sardarpura and Ratanada?",
      answer: "Yes! Recognizing Jodhpur's strong mercantile and trading heritage, our evening batches run from 7:00 PM to 9:00 PM (along with weekend morning slots), allowing business owners, professionals, and traders to participate without disrupting daytime business operations."
    },
    {
      question: "Does the curriculum focus on equity swing trading or index options for Jodhpur traders?",
      answer: "Both! Jodhpur traders learn institutional price action for equity swing compounding (ideal for business surplus capital) as well as mathematical option Greeks and non-directional hedging (Credit Spreads & Iron Condors) on Nifty & BankNifty."
    },
    {
      question: "Will I receive personal doubt resolution with Deepak Sir from Jodhpur?",
      answer: "Yes. Every Jodhpur batch student gets direct 1-on-1 trade journal audits, live weekly post-market Zoom reviews with Deepak Sir, and access to the dedicated priority mentor hotline for instant doubt clearance."
    },
    {
      question: "How does JamaDhan help Jodhpur traders transition from speculative tips to rule-based trading?",
      answer: "We systematically eliminate dependence on advisory channels and Telegram groups by teaching you how to read institutional order flow, volume footprint, and demand-supply imbalances with non-negotiable 1:2 or 1:3 risk-to-reward ratios."
    },
    {
      question: "What language are classes conducted in for Jodhpur cohorts?",
      answer: "Classes are taught in simple, crystal-clear Hindi with standard English market terminology, ensuring every concept is thoroughly understood by both beginners and experienced regional traders."
    }
  ],

  udaipur: [
    {
      question: "What makes JamaDhan the premier stock market institute for learners in Udaipur?",
      answer: "JamaDhan offers NISM-aligned institutional price action coaching led directly by Deepak Sethia (12+ years experience), combining 4K live interactive digital sessions, lifetime mentorship, proprietary Drishti AI screening, and complete transparency with zero speculative tip gambling."
    },
    {
      question: "Are these stock market classes suitable for college students from MLSU or CTAE in Udaipur?",
      answer: "Absolutely. Many students from Mohanlal Sukhadia University (MLSU), CTAE, and colleges near Chetak Circle and Sukher start with our Free Smart Trader Elementary Course to master financial literacy, candlestick basics, and risk control before progressing to advanced derivative strategies."
    },
    {
      question: "Can tourism, hospitality, and marble business owners in Udaipur benefit from these classes?",
      answer: "Yes! Udaipur's entrepreneurs and hospitality leaders frequently enroll to build disciplined secondary income streams. Our rule-based swing and positional trading modules require only 30 minutes of daily post-market analysis, fitting easily around busy enterprise schedules."
    },
    {
      question: "How do Udaipur students practice during live market hours?",
      answer: "Students join live market screen-sharing labs where Deepak Sir identifies live order block reactions, liquidity traps, and breakout candidates between 9:15 AM and 3:30 PM, letting you experience real market pressure in a structured learning environment."
    },
    {
      question: "What happens if I miss a live class due to work or university commitments in Udaipur?",
      answer: "Every single session is recorded in HD 1080p and uploaded to your personal student dashboard within 2 hours, with unlimited lifetime replay access and attached study notes."
    },
    {
      question: "Do Udaipur alumni get access to the physical trading floor in Jaipur?",
      answer: "Yes! Udaipur students can visit and trade from our high-tech Jaipur physical trading floor during campus workshops or whenever traveling to the state capital at no extra charge."
    }
  ],

  kota: [
    {
      question: "Why is JamaDhan's data-driven approach particularly effective for Kota students and faculty?",
      answer: "Kota is India's hub of analytical thinkers, engineers, and educators. JamaDhan's curriculum avoids guesswork and gut feelings, treating the market as a game of mathematical probabilities, auction theory, statistical risk-reward, and systematic risk management."
    },
    {
      question: "What are the batch timings for coaching faculty, students, and professionals in Kota?",
      answer: "To accommodate Kota's intensive study and teaching schedules around Vigyan Nagar, Talwandi, and Mahaveer Nagar, we offer late evening batches (8:00 PM - 10:00 PM) as well as dedicated weekend sessions with complete lifetime recordings."
    },
    {
      question: "Do I need a commerce or mathematics background to join from Kota?",
      answer: "Not at all. We start from absolute zero: demat account setup, candlestick psychology, and market structure before advancing to complex multi-timeframe demand-supply zones and derivatives math."
    },
    {
      question: "How does JamaDhan help Kota youth avoid F&O gambling traps?",
      answer: "Over 90% of retail options traders lose money because of zero risk management and chasing fast money. At JamaDhan, we teach strict capital preservation: never risking more than 1-2% per trade, hedging options through spreads, and building psychological discipline."
    },
    {
      question: "Will I get access to automated stock scanning tools like Drishti AI in Kota?",
      answer: "Yes! Our proprietary Drishti AI scanner is provided to students to automatically filter high-momentum breakouts, demand-supply zone reversals, and volume spikes across 500+ NSE stocks in real-time."
    },
    {
      question: "Can Kota students book 1-on-1 mentorship sessions with Deepak Sir?",
      answer: "Yes, every student receives 1-on-1 personalized portfolio and trade journal audits directly with Deepak Sethia to identify leakage points and refine trade entries."
    }
  ],

  ajmer: [
    {
      question: "How do traders and students from Ajmer and Kishangarh access JamaDhan's classes?",
      answer: "Because Ajmer is just a 1.5-hour highway drive from our Jaipur flagship center on Ajmer Road, Ajmer and Kishangarh students enjoy the best of both worlds: daily live interactive online sessions plus convenient weekend visits to our physical trading floor for live market workshops."
    },
    {
      question: "Are these courses helpful for Kishangarh marble and export business families?",
      answer: "Yes. Many industrial families in Ajmer and Kishangarh learn our institutional price action and options hedging to protect business surplus capital, manage risk against market inflation, and generate passive quarterly returns."
    },
    {
      question: "What is the duration of stock market courses for Ajmer students?",
      answer: "Our foundational Smart Trader Elementary Course is a 7-session free workshop, the Super Trader Edge technical analysis course runs for 25 sessions (~6-8 weeks), and the comprehensive Super Trader Combo runs for 35 sessions (~10-12 weeks)."
    },
    {
      question: "Does the program teach intraday trading or long-term wealth compounding?",
      answer: "Both modules are thoroughly covered: intraday price action (for daily momentum) and institutional weekly/monthly demand-supply zones (for multi-bagger positional swing trading and long-term portfolio compounding)."
    },
    {
      question: "Will I receive NISM-aligned certification in Ajmer?",
      answer: "Yes! Upon completing all module requirements, practical journal reviews, and assessments, you will receive an official JamaDhan Certificate of Completion with NISM-aligned technical and derivative standards."
    },
    {
      question: "How do I clear doubts if I am attending online from Ajmer?",
      answer: "You can ask questions via two-way microphone during live sessions, post screenshots in our private student community 24/7, or hop on our weekly dedicated doubt clearing Zoom calls with Deepak Sir."
    }
  ],

  sikar: [
    {
      question: "Are JamaDhan's stock market classes suitable for defense and competitive exam aspirants in Sikar?",
      answer: "Yes! Sikar and Shekhawati are famous for hard-working youths preparing for defense, civil services, and technical exams. Many students enroll to build a lifelong skill and sustainable secondary income stream through disciplined rule-based market execution."
    },
    {
      question: "Are the classes taught in Hindi for students in Sikar and Shekhawati?",
      answer: "Yes. 100% of our live instruction is delivered in fluent, conversational Hindi with clear visual examples and zero confusing English jargon. We ensure every candidate understands every concept deeply."
    },
    {
      question: "How much capital is required to start trading after completing the course in Sikar?",
      answer: "You can start practicing with as little as ₹5,000 to ₹10,000 in equity cash. We strictly advise against large capital or naked option buying until you have completed paper trading and at least 30 disciplined trades adhering to our risk calculator."
    },
    {
      question: "How can students from Piprali Road or Nawalgarh attend?",
      answer: "Students join our interactive digital cohort from their laptop or smartphone. The sessions feature live TradingView screen sharing, step-by-step order placement demos, and interactive Q&A."
    },
    {
      question: "What support is provided after the batch ends in Sikar?",
      answer: "Lifetime mentorship! You remain a permanent member of the JamaDhan trader network, receiving daily pre-market levels, weekly recap sessions, and the freedom to request setup audits whenever you need."
    },
    {
      question: "Can Sikar students visit the Jaipur physical trading center?",
      answer: "Absolutely. Sikar is well-connected to Jaipur via highway and train; our students regularly attend weekend special bootcamps and annual trader conclaves at our Heera Nagar physical institute."
    }
  ],

  bhilwara: [
    {
      question: "How is JamaDhan's trading curriculum designed for textile industrialists and CA professionals in Bhilwara?",
      answer: "Bhilwara's vibrant manufacturing, textile, and commerce community demands strict financial discipline and risk control. Our curriculum focuses heavily on capital preservation, non-directional option selling spreads, and multi-asset hedging rather than risky intraday speculation."
    },
    {
      question: "Can I balance the course with a full-time manufacturing or corporate schedule in Bhilwara?",
      answer: "Yes. Live sessions are held in the evening (7:00 PM - 9:00 PM) and on weekends, accompanied by full HD recordings and cheat sheets so you can learn at your own pace without sacrificing business responsibilities."
    },
    {
      question: "Do you teach commodity trading (Gold, Silver, Crude) along with equities for Bhilwara traders?",
      answer: "Yes! The Demand & Supply zone price action methodology pioneered by Deepak Sir is universal and applies seamlessly to NSE Equities, Nifty/BankNifty Indices, and MCX Commodities (Gold, Silver, Crude Oil, Natural Gas)."
    },
    {
      question: "How does the risk management module protect my business capital?",
      answer: "We teach institutional position sizing, dynamic stop-loss placement, and portfolio allocation rules. You will learn how to cap maximum drawdown to under 1.5% per trade while targeting minimum 1:2 or 1:3 profit objectives."
    },
    {
      question: "Will I get direct mentorship from Deepak Sethia from Bhilwara?",
      answer: "Yes! All live sessions, portfolio reviews, and strategy masterclasses are conducted directly by founder Deepak Sethia, ensuring you receive institutional-grade guidance with no junior faculty handoffs."
    },
    {
      question: "Can Bhilwara students attend physical floor trading in Jaipur?",
      answer: "Yes! Bhilwara students receive lifetime open invitations to trade from our multi-screen physical trading floor in Jaipur whenever they visit or attend our quarterly weekend retreats."
    }
  ]
};

export const CITY_FAQS = CITY_FAQS_BY_SLUG.jaipur;

export const MENTOR_INFO = {
  name: "Deepak Sethia",
  role: "Founder & Lead Market Strategist",
  experience: "12+ Years Market Experience",
  credentials: "NISM Certified • 10,000+ Students Mentored",
  image: "/deepak-sir.webp",
  bio: "Deepak Sethia is a professional full-time trader and mentor with over a decade of experience navigating Indian equities, indices, and derivatives. He pioneered the rule-based Demand & Supply zone methodology at JamaDhan, focusing on strict risk-to-reward ratios and capital preservation rather than speculative gambling.",
  highlights: [
    "Over 12+ years of live trading floor execution experience",
    "Trained 10,000+ retail traders across Rajasthan & India",
    "Specialist in Institutional Order Flow & Price Action",
    "NISM Certified Technical Analyst & Derivatives Strategist"
  ]
};
